__turbopack_context__.v({
  "leftText": "Who-module__6baVjq__leftText",
  "longDesc": "Who-module__6baVjq__longDesc",
  "rightText": "Who-module__6baVjq__rightText",
  "textContainer": "Who-module__6baVjq__textContainer",
  "whoAreWe": "Who-module__6baVjq__whoAreWe",
  "whoAreWeText": "Who-module__6baVjq__whoAreWeText",
});
